<template>
  <div class="box8" ref="box8">
    <pageTitle
      title="拒绝无效学习 选择合适班型"
      text="一站式服务，陪伴式学习，为你就业保驾护航"
      titleColor="#000D4D"
      titColor="#5A628A"
      ref="pageTitle"
    />

    <div
      class="serve-top"
      :style="{ position: isShow ? 'relative' : 'sticky' }"
    >
      <div class="left">服务项</div>
      <div class="right">
        <p>
          尊享
          <br />无忧
        </p>
        <p>尊享</p>
        <p>会员制</p>
      </div>
    </div>

    <div
      class="item-box"
      :class="{ space: isShow == false }"
      :style="{ height: isShow ? '12rem' : 'auto' }"
    >
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        :class="{ line: item.isTiele == true }"
      >
        <div class="left" :class="{ title: item.isTiele == true }">
          {{ item.serveName }}
        </div>
        <div class="right">
          <div v-for="(item1, index1) in item.isServe" :key="index1">
            <img
              v-if="item1 == 'true'"
              src="../../../assets/coursePage/ai/box11/true.png"
              alt
            />
            <div v-if="item1 !== 'true'">{{ item1 }}</div>
          </div>
        </div>
      </div>

      <div
        class="hiddent-box"
        @click="changeShow"
        :class="[isShow ? '' : 'hiddent-box2']"
      >
        {{ isShow ? "展开" : "收起" }}
        <img
          :class="{ 'img-rotate': !isShow }"
          src="../../../assets/coursePage/ai/box11/open.png"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          serveName: "入学筛选",
          isServe: ["", "", ""],
          isTiele: true,
        },
        {
          serveName: "入学条件",
          isServe: ["true", "-", "-"],
          isTiele: false,
        },
        {
          serveName: "学前测评",
          isServe: ["true", "-", "-"],
          isTiele: false,
        },
        {
          serveName: "入学测评",
          isServe: ["true", "-", "-"],
          isTiele: false,
        },
        {
          serveName: "基础服务",
          isServe: ["", "", ""],
          isTiele: true,
        },
        {
          serveName: "黑马优质课程体系",
          isServe: ["true", "true", "true"],
          isTiele: false,
        },
        {
          serveName: "博学谷一体化学习平台",
          isServe: ["true", "true", "true"],
          isTiele: false,
        },
        {
          serveName: "课程长期更新",
          isServe: ["true", "true", "服务期内更新"],
          isTiele: false,
        },
        {
          serveName: "视频长期可看",
          isServe: ["true", "true", "true"],
          isTiele: false,
        },
        {
          serveName: "尊享导学",
          isServe: ["", "", ""],
          isTiele: true,
        },
        {
          serveName: "学习计划",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "线上小班群",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "直播串讲",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        // {
        //   serveName: "项目实战（学员实操）",
        //   isServe: ["true", "true", "-"],
        //   isTiele: false,
        // },
        {
          serveName: "单元测评",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "阶段测评",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "结业测评",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "无忧陪跑",
          isServe: ["", "", ""],
          isTiele: true,
        },
        {
          serveName: "班主任督学",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "导（讲）师督学",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "客服系统答疑",
          isServe: ["-", "-", "true"],
          isTiele: false,
        },

        {
          serveName: "小助手答疑",
          isServe: ["-", "-", "true"],
          isTiele: false,
        },
        {
          serveName: "导师群答疑",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "一对一远程答疑",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },

        {
          serveName: "就业服务",
          isServe: ["true", "true", "-"],
          isTiele: false,
        },
        {
          serveName: "就业薪资保障",
          isServe: ["true", "-", "-"],
          isTiele: false,
        },
      ],
      isShow: true,
    };
  },
  methods: {
    changeShow() {
      if (this.isShow)
        this.scrollToHeight = document.querySelector("#box9").offsetTop;
      this.isShow = !this.isShow;
      if (this.isShow)
        window.scrollTo(
          0,
          this.scrollToHeight - this.$refs.pageTitle.$el.offsetTop * 3
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.box8 {
  position: relative;
  padding-top: 80px;
  width: 100%;
  background-color: #ffffff;
  // background: url("../../../assets/coursePage/ai/box11/bg.png") no-repeat;
  // background-size: contain;
  // height: 1168px;
  // box-sizing: border-box;

  .img-rotate {
    transition: 0.5s ease all;
    transform: rotate(180deg);
  }

  .serve-top {
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    margin-top: -40px;
    padding-top: 88px;
    margin-bottom: 32px;
    width: 686px;
    height: 104px;
    background: #fff;
    // box-sizing: border-box;
    z-index: 10;
    .left {
      margin-left: 16px;
      font-size: 32px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: #1d2129;
    }
    .right {
      display: flex;

      width: 358px;
      height: 104px;
      background: #94bfff;

      border-radius: 20px;
      overflow: hidden;
      p {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 100%;
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;

        &:nth-child(1) {
          background: #4080ff;
        }
        &:nth-child(2) {
          background: #6aa1ff;
        }
      }
    }
  }

  .hiddent-box {
    position: absolute;
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    // height: 50px;
    height: 150px;
    padding-top: 30px;
    box-sizing: border-box;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.6) 0%,
      #ffffff 70%,
      #ffffff 100%
    );
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #86909c;
    cursor: pointer;
    z-index: 10;
    transition: 0.3s ease all;
    img {
      margin-left: 4px;
      width: 32px;
      height: 32px;
    }
  }
  .hiddent-box2 {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 40%,
      #ffffff 70%,
      #ffffff 100%
    );
  }
  .item-box {
    position: relative;
    padding-bottom: 0px;
    // height: 900px;
    img {
      width: 32px;
      height: 32px;
    }
    overflow: hidden;
  }

  .space {
    padding-bottom: 96px;
    background: transparent;
  }

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding-left: 16px;
    width: 686px;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    .left {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .title {
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #1d2129;
      line-height: 40px;
    }
    .right {
      display: flex;
      width: 358px;
      height: 104px;
      // background: #94bfff;
      border-radius: 20px;
      overflow: hidden;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 8px;
        width: 120px;
        height: 100%;
        text-align: center;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 34px;
        box-sizing: border-box;
      }
    }
  }
  .line {
    border-bottom: 1px solid #f3f4f6;
  }
}
</style>
